import { QueryClientProvider } from "@tanstack/react-query";
import { APIProvider } from "@vis.gl/react-google-maps";
import { PostHogProvider } from "posthog-js/react";
import { Toaster } from "sonner";

import { DialogManager } from "./dialogs/dialog-manager";
import client from "./lib/client";
import { GOOGLE_MAPS_API_KEY, POSTHOG_HOST, POSTHOG_KEY } from "./lib/env";
import Routes from "./routes";

export const App = () => (
  <PostHogProvider apiKey={POSTHOG_KEY} options={{ api_host: POSTHOG_HOST }}>
    <QueryClientProvider client={client}>
      <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
        <DialogManager>
          <Routes />
          <Toaster />
        </DialogManager>
      </APIProvider>
    </QueryClientProvider>
  </PostHogProvider>
);
